import React, { FC, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { ProductApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	isShown: boolean;
	onHide: () => void;
	index: number;
	form: UseFormReturn<ProductApi>;
}

const GenerateProductBarcodeModalForm: FC<Props> = ({ isShown, onHide, index, form }) => {
	const { t } = useTranslation();
	const { setValue, getValues } = form;
	const [prefixValue, setPrefixValue] = useState<string>(getValues(`custom_ids.${index}.value`) ?? "");

	const onGenerate = () => {
		if (getValues(`custom_ids.${index}.type`) !== "BARCODE") {
			setValue(`custom_ids.${index}.type`, "BARCODE");
		}
		let newPrefixValue = getRandomBarcodeNumber(prefixValue).toString();
		setValue(`custom_ids.${index}.value`, newPrefixValue);
		setPrefixValue("");
		onHide();
	};

	const getRandomBarcodeNumber = (currentPrefix: string) => {
		const amountOfZeroDigit = 13 - (currentPrefix?.length || 0);
		if (amountOfZeroDigit === 0) return currentPrefix;

		const min = amountOfZeroDigit > 0 ? "1".padEnd(amountOfZeroDigit, "0") : 1;
		const max = amountOfZeroDigit > 0 ? "9".padEnd(amountOfZeroDigit, "0") : 9;
		return currentPrefix + Math.floor(Number(min) + Math.random() * Number(max));
	};

	const typeOptions = [{ value: "EAN-13", label: "EAN-13" }];
	const customStyles = {
		control: (provided: Record<string, any>) => ({
			...provided,
			minHeight: "30px",
			height: "30px",
		}),
		valueContainer: (provided: Record<string, any>) => ({
			...provided,
			height: "30px",
			padding: "0 6px",
		}),
		input: (provided: Record<string, any>) => ({
			...provided,
			margin: "0px",
		}),
		indicatorsContainer: (provided: Record<string, any>) => ({
			...provided,
			height: "30px",
		}),
	};

	return (
		<Modal onHide={onHide} show={isShown}>
			<Modal.Header closeButton>
				<Modal.Title>{t("modules.product.field.generate_barcode.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Label className="mb-0 label text-muted">{t("lib:common.word.type")}</Form.Label>
				<Select
					value={typeOptions[0]}
					styles={customStyles}
					defaultValue={typeOptions[0]}
					options={typeOptions}
				/>
				<Form.Label className="mt-3 mb-0 label text-muted">
					{t("modules.product.field.prefix.title")}
				</Form.Label>
				<input
					className="form-control"
					placeholder={t("modules.product.field.prefix.placeholder")}
					defaultValue={getValues(`custom_ids.${index}.value`)}
					onChange={(e) => setPrefixValue(e.target.value)}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button type="submit" onClick={onGenerate}>
					{t("modules.product.action.generate.title")}
				</Button>
				<Button variant="light" onClick={onHide}>
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default GenerateProductBarcodeModalForm;
